<template>
    <div class="no-internet" v-show="!onLine">
        <i class="fas fa-exclamation-triangle"></i> No internet connection!
    </div>
</template>

<style lang="scss" scoped>
    .no-internet {
        background: #dc3545;
        padding: 15px;
        text-align: center;
        margin: 0 auto;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border: 0;

        i {
            margin-right: 15px;
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                onLine: true,
            }
        },
        methods: {
            amIOnline() {
                this.onLine = navigator.onLine || false;
            },
        },
        created(){
            window.addEventListener('load', this.amIOnline)
            window.addEventListener('online', this.amIOnline)
            window.addEventListener('offline', this.amIOnline)
        }
    }
</script>